export default __webpack_public_path__ + "0bdcd3d6b9098f2bce0fbe55cf194803.png";